import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from 'react-table';

import { Table } from '@/lib/components/Table';
import { Flex } from '@/lib/v2/components';
import { EmptyScreenTable } from '@/lib/v2/examples';
import { EmptyCampaignsIcon, EmptyContactsIcon } from '@/lib/v2/icons/general';
import { ListIcon } from '@/lib/v2/icons/solid';

import { ICampaignsTableProps } from '@/src/modules/CampaignsModule/interfaces/Interfaces';

import { EmptyTableWithoutData } from './components/EmptyTableWithoutData';

export function CampaignsTable({ callToAction }: ICampaignsTableProps) {
  const { t } = useTranslation();

  const nameColumn = {
    Header: () => (
      <Flex withGap alignment="start">
        <ListIcon />
        <span className="text-emblue-primary"> {t('NPS_SCREEN.nameColumn')} </span>
      </Flex>
    ),
    accessor: 'widget',
    id: 'widget',
    Cell: ({ cell: { value } }: { cell: { value: string } }) => (
      <Flex withGap alignment="start">
        <Flex column noGrow>
          <span
            className="self-start truncate text-emblue-subheadings md:max-w-[200px] 2xl:max-w-[300px]"
            title={value}
          >
            {value}
          </span>
        </Flex>
      </Flex>
    ),
  };

  const CampaignsColumns: Column<object>[] = [nameColumn].filter((x) => x) as Column<object>[];

  const handleClickEmptyScreen = useCallback(() => {
    callToAction && callToAction[0]();
  }, [callToAction]);

  return (
    <div className="w-full text-base text-[#364365] 2xl:text-14">
      <Table
        noNegativeMargin
        paginationWithPadding
        columns={CampaignsColumns}
        data={[]}
        emptyScreen={{
          totalCount: 0,
          noResult: (
            <EmptyScreenTable
              actionText={t('EMPTY_SCREEN_TABLE.groups')}
              description={t('EMPTY_SCREEN_TABLE.callToAction')}
              image={<EmptyContactsIcon />}
              title={t('EMPTY_SCREEN_TABLE.noResults')}
            />
          ),
          noData: (
            <EmptyScreenTable
              descriptionNode={<EmptyTableWithoutData onClickAction={handleClickEmptyScreen} />}
              image={<EmptyCampaignsIcon />}
              title={t('CAMPAIGNS_MAIN.EMPTY_SCREEN_TABLE.emptyCampaignsTitle')}
            />
          ),
        }}
      />
    </div>
  );
}
